<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="email"
      name="email"
      :label="$t('forms.email')"
      :rules="[v => !!v || $t('forms.emailRequired')]"
      required
      light
    />

    <v-text-field
      v-model="password"
      type="password"
      :label="$t('forms.password')"
      :rules="[v => !!v || $t('forms.passwordRequired')]"
      required
      light
    />

    <v-btn
      color="primary"
      block
      @click="validate"
    >
      Login
    </v-btn>
  </v-form>
</template>

<script>
import gql from "graphql-tag";
export default {
  data: () => ({
    form: 'login',
    valid: true,
    email: null,
    password: null
  }),

  methods: {
    validate () {
      this.$refs.form.validate();
      if (this.valid) {
        this.$apollo
          .mutate({
            // Query
            mutation: gql`
              query(
                $email: String!
                $password: String!
              ) {
                login(
                    email: $email
                    password: $password
                  )
                 {
                  token
                  userId
                  username
                }
              }
            `,
            variables: {
              email: this.email,
              password: this.password,
            },
          })
          .then((data) => {
            this.gotoApp(data.data.login.token);
            
          })
          .catch(() => {});
      }
    },
    gotoApp(token) {
      localStorage.setItem("apollo-token", "Bearer "+token);
      this.$router.push({ name: "app" }); //  params: { userId } }) // -> /user/123
    },
  }
}
</script>

<style scoped>
.EntryForm {
    position: relative;
    right: -500px;
    -webkit-animation: slide 0.5s forwards;
    -webkit-animation-delay: 2s;
    animation: slide 1s forwards;
    animation-delay: 1.3s;
}

@-webkit-keyframes slide {
    100% { right: 0; }
}

@keyframes slide {
    100% { right: 0; }
}
</style>
